// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"c67cdb00","294":"f0fbe170","362":"52629f4c","369":"998da246","447":"044067b9"}[chunkId] + ".chunk.js";
};